import { render, staticRenderFns } from "./AddShipmentDrawer.vue?vue&type=template&id=7aa36119&"
import script from "./AddShipmentDrawer.vue?vue&type=script&lang=ts&"
export * from "./AddShipmentDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports